import BaseService from '@core/class/BaseService';
// import { dataFake } from '../Constants';
import { IPagination } from '../interfaces';
class ProductServices extends BaseService {
  public fetchData = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let data = [...Array(10)].map((item, index) => ({
      ...item,
      ...{
        productName: ['', 't-Shirt', 'Jean', 'Kaky', 'Hat'][
          Math.ceil(Math.random() * 3)
        ],
        quantity: [1, 1, 3, 5, 6, 8][Math.ceil(Math.random() * 5)],
        SSKU: 33012 + Number(index),
        centerName: ['', 'Old', 'New'][Math.ceil(Math.random() * 2)],
        UpdateDate:
          new Date().getTime() +
          [0, 1000, 10000, 3000][Math.ceil(Math.random() * 3)]
      }
    }));
    return { data: data };
  };

  public getPaging = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = 'api/v1/seller/products/list-imported' + `?page=${page}&limit=10`;
    url =
      productName !== '' &&
      productName !== null &&
      fieldSearch !== '' &&
      !!fieldSearch
        ? (url += `&filter.${fieldSearch}=${productName}`)
        : url;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  //api export excel all
  public exportExcel = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = `api/v1/seller/products/list-imported/export-all?`;
    // url = (!!productName &&
    //       !!fieldSearch) || !!sort || !!fromDt || !!toDt ? url + '?' : url;
    console.log(!!productName && !!fieldSearch, productName, fieldSearch, 1000);
    url +=
      (!!productName && !!fieldSearch
        ? `&filter.${productName}=${fieldSearch}`
        : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.from=${fromDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');
    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  //api export excel follow array id
  public exportExcelById = (productId: number[]) => {
    let value = 'ids=';
    productId.forEach((item: number) => {
      value = value + item + ',';
    });
    return this.get(
      `api/v1/seller/products/list-imported/export?${value.substring(
        0,
        value.length - 1
      )}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  //api get detail product
  public getDetailProduct = (productId: number | string) => {
    return this.get(`api/v1/seller/products/detail/${productId}`);
  };

  public getReceivingDetails = (
    productId: number,
    body: Record<string, any>
  ) => {
    return this.get(
      `api/v1/seller/products/list-product-by-product-imported/${productId}`,
      body
    );
  };
}

export default new ProductServices('/', true);
